var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle42A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M22.5 54a2.5 2.5 0 0 1-2.5-2.5v-43A2.5 2.5 0 0 1 22.5 6h15A2.5 2.5 0 0 1 40 8.5v43a2.5 2.5 0 0 1-2.5 2.5h-15ZM6 50v-3h10v1.237a2.5 2.5 0 0 1-2.749 2.488L6 50ZM6 10v3h10v-1.238a2.5 2.5 0 0 0-2.749-2.487L6 10ZM6 47V13h10v34z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6 9v42"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 10v3H44v-1.238a2.5 2.5 0 0 1 2.749-2.487L54 10ZM54 50v-3H44v1.237a2.5 2.5 0 0 0 2.749 2.488L54 50ZM54 13v34H44V13z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M54 51V9"
})));
SvgRectangle42A.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle42A);
export default ForwardRef;